import { createStackSiderViewHook } from '@/providers/StackSiderViewProvider';

export const useWorkflowStackSiderView = createStackSiderViewHook('workflow');
